import { fetchCompanyClients, fetchCompanyClientsUnassigned } from "../../companyClients/api/companyClients";
import { fetchCompanyProperties, fetchCompanyPropertiesUnassigned } from "../../companyProperties/api/companyProperties";
import {
  fetchCompanyTasks,
  fetchCompanyViewings,
} from "../../companyWork/api/companyWork";
import {
  fetchCompanyFinanceObligations,
  fetchCompanyFinanceReceipts,
} from "../../companyWorkspace/api/companyFinance";
import { authoritativeListCount } from "../lib/overviewMetrics";

const COUNT_PAGE = { page: 1, page_size: 1 };

export async function fetchMetricCount(source, companyId) {
  let payload;
  switch (source) {
    case "clients":
      payload = await fetchCompanyClients(companyId, COUNT_PAGE);
      break;
    case "properties":
      payload = await fetchCompanyProperties(companyId, COUNT_PAGE);
      break;
    case "tasks_todo":
      payload = await fetchCompanyTasks(companyId, {
        ...COUNT_PAGE,
        status: "todo",
      });
      break;
    case "tasks_in_progress":
      payload = await fetchCompanyTasks(companyId, {
        ...COUNT_PAGE,
        status: "in_progress",
      });
      break;
    case "tasks_overdue":
      payload = await fetchCompanyTasks(companyId, {
        ...COUNT_PAGE,
        is_overdue: true,
      });
      break;
    case "viewings_scheduled":
      payload = await fetchCompanyViewings(companyId, {
        ...COUNT_PAGE,
        status: "scheduled",
      });
      break;
    case "clients_unassigned":
      payload = await fetchCompanyClientsUnassigned(companyId, COUNT_PAGE);
      break;
    case "properties_unassigned":
      payload = await fetchCompanyPropertiesUnassigned(companyId, COUNT_PAGE);
      break;
    case "finance_receipts":
      payload = await fetchCompanyFinanceReceipts(companyId, COUNT_PAGE);
      break;
    case "finance_obligations":
      payload = await fetchCompanyFinanceObligations(companyId, COUNT_PAGE);
      break;
    default:
      throw new Error(`unknown_metric_source:${source}`);
  }
  const count = authoritativeListCount(payload);
  if (count == null) {
    const err = new Error("missing_authoritative_count");
    err.code = "missing_authoritative_count";
    throw err;
  }
  return count;
}
